import { useState } from "react";
import NotificationManager from "../../components/notifications/NotificationManager";
import WatsonApi from "../../backends/WatsonApi";
import { useStores } from "../../stores/useStores";
import { runInAction } from "mobx";

export function TechSupportSettings() {
  const { organizationStore } = useStores();
  const [hasChanged, setHasChanged] = useState(false);
  const [code, setCode] = useState(
    organizationStore.organization.json_data.settings.support?.code || "",
  );
  const [authenticatedOnly, setAuthenticatedOnly] = useState(
    organizationStore.organization.json_data.settings.support
      ?.authenticatedOnly || false,
  );

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const client = await WatsonApi();
      client.apis.settings;
      const response = await client.apis.settings.settings_update({
        id: organizationStore.currentOrganization.id,
        data: {
          support: {
            code: code,
            authenticatedOnly: authenticatedOnly,
          },
        },
      });

      const settings = response.body.settings;
      if (settings) {
        runInAction(() => {
          organizationStore.organization.json_data.settings = settings;
        });
        NotificationManager.success("Settings successfully updated!");
      }
    } catch (e) {
      switch (e.statusCode) {
        case 400:
          NotificationManager.error("Bad Request: Settings not updated.");
          break;
        case 404:
          NotificationManager.error(
            "Not Found: Organization settings not found.",
          );
          break;
        case 500:
          NotificationManager.error(
            "Internal Server Error: Settings not updated.",
          );
          break;
        default:
          NotificationManager.error("Unknown Error: Settings not updated.");
      }
    }
  }

  return (
    <div role="tabpanel">
      <div className="sb-settings-block-content-heading">
        <h4>Technical Support Widget</h4>
      </div>
      <div>
        <p>
          If your district or school has IT Help Desk software that you would
          like to make accessible to logged in users, then paste the code for
          your Help Desk widget into the text area below.
        </p>
      </div>
      <form
        id="tech-support-form"
        onSubmit={handleSubmit}
        onChange={() => setHasChanged(true)}
      >
        <div className="row">
          <div className="col-sm-3">
            <label>Widget Code</label>
          </div>
          <div className="col-sm-4">
            <textarea
              title="Widget code"
              rows={8}
              placeholder="Paste tech support widget code"
              onChange={(e) => setCode(e.target.value)}
              value={code}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <label>Only show Widget Code to logged in users</label>
          </div>
          <div className="col-sm-4">
            <input
              title="Toggle widget code visibility for logged in users"
              type="checkbox"
              className="checkbox-default-links"
              checked={authenticatedOnly}
              onChange={() => setAuthenticatedOnly((v) => !v)}
            />
          </div>
        </div>
        <div className="sb-settings-block-footer">
          <button
            type="submit"
            className="btn sb-organization-color-element-bg"
            name="submit"
            disabled={!hasChanged}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
